import type { Template } from "@/types";

export const PO_02_H2_V0: Template[] = [
{
    id: "po-02-h2v0-01",
    name: "PO 01 - H2V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h2_v0_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "1", x: 0, y: 217, width: 564, height: 420, rotation: 0, imageRotation: 0 },
            { id: "2", x: 572, y: 217, width: 564, height: 420, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-02-h2v0-02",
    name: "PO 02 - H2V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h2_v0_02.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 41, y: 246, width: 488, height: 363, rotation: 0, imageRotation: 0 },
            { id: "2", x: 609, y: 246, width: 488, height: 363, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h2v0-03",
    name: "PO 03 - H2V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h2_v0_03.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 68, y: 246, width: 496, height: 363, rotation: 0, imageRotation: 0 },
        { id: "2", x: 572, y: 246, width: 496, height: 363, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h2v0-04",
    name: "PO 04 - H2V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h2_v0_04.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 36, y: 246, width: 497, height: 363, rotation: 0, imageRotation: 0 },
            { id: "2", x: 666, y: 292, width: 370, height: 270, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h2v0-05",
    name: "PO 05 - H2V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h2_v0_05.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 99, y: 292, width: 370, height: 270, rotation: 0, imageRotation: 0 },
            { id: "2", x: 603, y: 246, width: 497, height: 363, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h2v0-06",
    name: "PO 06 - H2V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h2_v0_06.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 41, y: 444, width: 488, height: 363, rotation: 0, imageRotation: 0 },
            { id: "2", x: 609, y: 444, width: 488, height: 363, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-02-h2v0-07",
    name: "PO 07 - H2V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-02-h2_v0_07.png",
    size: [1136, 854],
    style: {},
    slots: [
            { id: "1", x: 666, y: 292, width: 370, height: 270, rotation: 0, imageRotation: 0 },
            { id: "2", x: 98, y: 292, width: 370, height: 270, rotation: 0, imageRotation: 0 }
    ],
}
];